// extracted by mini-css-extract-plugin
export default {"UserMenu":"UserMenu_UserMenu__BJa0F","UserMenuAvatar":"UserMenu_UserMenuAvatar__WHz1x"};